import {UTIL_CONSTS} from "../constants/utilConsts";

export const initialState = {
    isMobile: false,
    isFullWidth: false,
    activeMenuId: ["0"],
    headerTitle: '',
    eventsColor: {},
    detectedExtension: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UTIL_CONSTS.SET_MOBILE:
            return {
                ...state,
                isMobile: action.payload,
            };
        case UTIL_CONSTS.DETECTED_EXTENSION:
            return {
                ...state,
                detectedExtension: action.payload,
            };
        case UTIL_CONSTS.SET_FULL_WIDTH:
            return {
                ...state,
                isFullWidth: action.payload,
            };
        case UTIL_CONSTS.CHANGE_HEADER_TITLE:
            return {
                ...state,
                headerTitle: action.payload,
            };
        case UTIL_CONSTS.UPDATE_MENU_ACTIVE:
            return {
                ...state,
                activeMenuId: action.payload,
            };
        case UTIL_CONSTS.OPEN_MENU:
            return {
                ...state,
                activeMenuId: [...state.activeMenuId, action.payload],
            };
        case UTIL_CONSTS.EVENT_COLORS:
            return {
                ...state,
                eventsColor: {
                    id: action.payload.id,
                    colors: action.payload.data,
                },
            };

        default:
            return state;
    }
}
